module.exports = __webpack_public_path__ + "img/Aquifer mapping.c50399d5.jpg";